(function ($) {
  Drupal.behaviors.beautiful_belle_video_grid = {
    attach: function (context) {
      $('#belle_mod3', context).once(function () {
        var thisModuleName = 'belle_mod3';
        var triggerMod = '#belle_mod3';
        var $thismodule = $('#belle_mod3');
        var gridTile = $('.belle_mod3__tile.js-ytPlayer__icon');
        // If module is called in URL, scroll to module.
        var urlHash = window.location.href.split('#')[1];

        if (urlHash === thisModuleName) {
          $('html,body').animate(
            {
              scrollTop: $thismodule.offset().top - 85
            },
            1500
          );
        }

        // Check if Content Author has specified for module
        // to fade in.
        var moduleWillFade = false;
        var hasFaded = false;

        if ($thismodule.data('scrollmagic') === 1) {
          moduleWillFade = true;
        }

        // Hide and push down the module if it is to be faded in.
        if (moduleWillFade) {
          $thismodule.addClass('hideModules');
        }

        // Handle module fade-in from CMS.
        function fadeThisModule() {
          if (hasFaded === false) {
            hasFaded = true;
            $thismodule.animate(
              {
                opacity: 1,
                paddingTop: '0'
              },
              350,
              'easeOutQuad'
            );
          } else {
            return;
          }
        }

        // Show gif on tile hover
        if (!$('body').hasClass('device-mobile')) {
          gridTile.each(function () {
            var gridTileHover = $(this);
            var gridTileSrc = gridTileHover.find('.js-belle_mod3__tile-hover');
            var gridTileOn = gridTileSrc.data('hover-on');
            var gridTileOff = gridTileSrc.data('hover-off');

            gridTileHover.hover(
              function () {
                gridTileSrc.attr('src', gridTileOn);
              },
              function () {
                gridTileSrc.attr('src', gridTileOff);
              }
            );
          });
        }

        $(window).on('load', function () {
          // Content-Author-managed - Module Fade.
          if (moduleWillFade) {
            // Put in window load so that the page height is ready
            // by the time we get to animating.

            // Init scrollMagic Controller Class
            var controller = new ScrollMagic.Controller();
            var offset;

            // Set the offset.
            if ($thismodule.data('offset')) {
              offset = $thismodule.data('offset');
            } else {
              offset = 0;
            }

            // Init scrollMagic Scene Class
            var fadeThisModuleScene = new ScrollMagic.Scene({
              triggerElement: triggerMod,
              offset: offset
            }).on('start', function () {
              fadeThisModule();
            });

            controller.addScene([fadeThisModuleScene]);
          }
        });
      });
    }
  };
})(jQuery);
